import React from "react";
import Form from "./Form";

export default function AddNewBook({ onEdit, editMode, handleCancel }) {
  return (
    <div>
      <div className="p-4 overflow-hidden bg-white shadow-cardShadow rounded-md">
        <h4 className="mb-8 text-xl font-bold text-center">Add New Book</h4>
        <Form editMode={editMode} onEdit={onEdit} handleCancel={handleCancel} />
      </div>
    </div>
  );
}
